import { render, staticRenderFns } from "./batchTableNoMenu.vue?vue&type=template&id=56482d5b&scoped=true&"
import script from "./batchTableNoMenu.vue?vue&type=script&lang=js&"
export * from "./batchTableNoMenu.vue?vue&type=script&lang=js&"
import style0 from "./batchTableNoMenu.vue?vue&type=style&index=0&id=56482d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56482d5b",
  null
  
)

export default component.exports